import React from 'react';
import PlaceholderIcon from '../../../../modules/react/components/stateless/PlaceholderIcon';
import styles from './PayOnlineEntryAccordion.scss';
import PayOnlineAccordionItems from '../PayOnlineAccordionItems/PayOnlineAccordionItems';
import PanelComponent from '../PanelComponent';

const PayOnlineEntryAccordion = ({ stateFacilitiesMap,
  sortedStates,
  renderPayOnlineEntry,
  panelCloseStates,
  togglePanel }) => (
      <div className={styles.container}>
      {sortedStates.map(stateKey => (
        <div key={stateKey}>
         <button type="button" className={styles.toggleButton} onClick={() => togglePanel(stateKey)}>
            <span className={styles.accordionHeading}>
              {stateFacilitiesMap[stateKey].stateFullName}
            </span>
            <PlaceholderIcon.DownChevron
              className={panelCloseStates[stateKey] ? styles.rotateDown : styles.rotateUp}
              width="24"
              height="24"
              fill="#686868"
            />
         </button>
          <PanelComponent
            id={stateKey}
            isExpanded={!panelCloseStates[stateKey]}
            panelClass={styles.customPanel}
            panelBodyClass={styles.customPanelBody}
            onToggle={() => togglePanel(stateKey)}
          >
            <PayOnlineAccordionItems
              renderPayOnlineEntry={renderPayOnlineEntry}
              stateFacilities={stateFacilitiesMap[stateKey].facilities}
            />
          </PanelComponent>
        </div>
      ))}
      </div>
);

export default PayOnlineEntryAccordion;
